import auth from "../../middlewares/auth";
export const settingsDifficultyRoute = [
  {
    path: '/settings/difficulty',
    component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/difficulty/DifficultyList'),
    name: 'settings_difficulty',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/settings/difficulty/add',
    component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/difficulty/DifficultyForm'),
    name: 'settings_difficulty_add',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/settings/difficulty/edit/:id',
    component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/difficulty/DifficultyForm'),
    name: 'settings_difficulty_edit',
    meta: {
      middleware: [
        auth
      ]
    }
  }
];